var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGiftbox = function SvgGiftbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6518 6.96254C16.7882 6.89298 16.9196 6.81393 17.0449 6.72597C18.0608 6.01277 18.3739 4.7012 17.7407 3.80362C17.1076 2.90604 15.7716 2.75993 14.7558 3.48008C13.7399 4.20022 13.218 5.47353 12.651 6.95906L16.6518 6.96254ZM4.32227 11.5896H20.5378V19.8348C20.5378 20.2038 20.3912 20.5578 20.1303 20.8188C19.8693 21.0798 19.5153 21.2264 19.1463 21.2264H5.71386C5.34479 21.2264 4.99083 21.0798 4.72985 20.8188C4.46888 20.5578 4.32227 20.2038 4.32227 19.8348V11.5896Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.464 11.5896H10.3936V21.2264H14.464V11.5896Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20503 6.96254C8.0693 6.89374 7.93904 6.81465 7.81539 6.72597C6.79952 6.01278 6.48293 4.7012 7.11959 3.80362C7.75624 2.90604 9.0887 2.75993 10.108 3.48008C11.1274 4.20023 11.6423 5.47353 12.2128 6.95906L8.20503 6.96254Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2563 6.96236H4.60083C4.02441 6.96236 3.55713 7.42963 3.55713 8.00605V10.5457C3.55713 11.1221 4.02441 11.5894 4.60083 11.5894H20.2563C20.8327 11.5894 21.3 11.1221 21.3 10.5457V8.00605C21.3 7.42963 20.8327 6.96236 20.2563 6.96236Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8359 6.96236H10.0244V11.5894H14.8359V6.96236Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiftbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/giftbox.cd7a4f94.svg";
export { ForwardRef as ReactComponent };